import { assetsPath } from "../../../utils";

const baseAssetUrl = assetsPath("phuket-laguna-park-2");
const maps = `${baseAssetUrl}/images/site-plan/image.jpg`;

const type = [
  {
    value: "all",
    title: {
      en: "ALL",
      ru: "ALL",
      cn: "ALL",
    },
  },
  {
    value: "townhome",
    title: {
      en: "TOWNHOMES",
      ru: "Таунхаусы",
      cn: "联排别墅",
    },
  },
  {
    value: "villa",
    title: {
      en: "VILLAS",
      ru: "Виллы",
      cn: "独栋别墅",
    },
  },
];

const descriptions = [
  {
    value: "Villas",
    title: {
      en:
        "Offering generous and practical spaces for larger families, the three- storey villas sit on larger land plots averaging 375 sqm in size. Villas come with three to five bedrooms, as well as multiple living spaces and maid’s quarters with a separate entrance.",
      cn:
        "乐古浪熙园的三层独栋别墅空间更 加宽敞实用，平均面积375平方米， 适合更大的家庭。独栋别墅提供了 三间至五间卧室，此外还包括多功 能起居空间和一间拥有单独入口的 保姆房。",
      ru:
        "Трехэтажные виллы отличаются исключительной просторностью и практичностью, необходимые большим семьям. Площадь прилегающего участка в среднем составляет 375 кв.м. Виллы включают в себя три-пять спален, множество жилых помещений и помещение для прислуги с отдельным входом.",
    },
  },
  {
    value: "Townhomes",
    title: {
      en:
        "The three-storey townhomes at Laguna Park offer on average 220 sqm of space to live, work, play, and gather. Townhomes come with two or three bedrooms.",
      cn:
        "乐古浪熙园的三层联排别墅平均面 积220平方米，适合休息、工作、 玩乐和聚会。联排别墅提供了两间 或三间卧室。",
      ru:
        "Жилая площадь трехэтажных таунхаусов, расположенных в комплексе Laguna Park, составляет 220 кв. м. Это предоставляет множество возможностей для отдыха, работы, игр и встреч. Таунхаусы включают в себя две или три спальни.",
    },
  },
];

export default {
  maps: "",
  type,
  descriptions,
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaPark2/sitePlan/index.js